<meta
  name="viewport"
  content=" user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0"
/>
@if (data.register) {
  <div>
    <app-register></app-register>
  </div>
}
@if (data.id_factura) {
  <div>
    <app-modify [id_factura]="data.id_factura"></app-modify>
  </div>
}
@if (data.company) {
  <div>
    @if (data.companies.length > 0) {
      <div>
        <mat-dialog-content>
          <h4>Select company that you wish to see</h4>
          @for (company of data.companies; track company) {
            <button mat-button (click)="giveCompany(company)">
              {{ company.name }}
            </button>
          }
        </mat-dialog-content>
      </div>
    }
  </div>
}
@if (data.user) {
  <div>
    <app-register-user></app-register-user>
  </div>
}
@if (data.modifyUser) {
  <div>
    <app-modify-user [id_user]="data.id_user"></app-modify-user>
  </div>
}
@if (data.registerCustomer) {
  <div>
    <app-register-customer></app-register-customer>
  </div>
}
@if (data.modifyCustomer) {
  <div>
    <app-modify-customer [id_customer]="data.id_customer"></app-modify-customer>
  </div>
}
@if (data.registerSeller) {
  <div>
    <app-register-seller></app-register-seller>
  </div>
}
@if (data.modifySeller) {
  <div>
    <app-modify-seller [id_seller]="data.id_seller"></app-modify-seller>
  </div>
}
@if (data.registerArticle) {
  <div>
    <app-register-article
      [isCompoundArticle]="data.isCompoundArticle"
    ></app-register-article>
  </div>
}
@if (data.modifyArticle) {
  <div>
    <app-modify-article
      [id_article]="data.id_article"
      [isCompoundArticle]="data.isCompoundArticle"
      [id_compound_article]="data.id_compound_article"
    ></app-modify-article>
  </div>
}
@if (data.deliveryData) {
  <div>
    <app-delivery [dataD]="data.deliveryData"></app-delivery>
  </div>
}
@if (data.filtro) {
  <div>
    <app-filter
      [filtro]="data.newArticle"
      [currentWarehouse]="data.currentWarehouse"
    ></app-filter>
  </div>
}
@if (data.boolC === true) {
  <div>
    <app-credit-note [id_fact]="data.credit"></app-credit-note>
  </div>
}
@if (data.boolD === true) {
  <div>
    <app-debit-note [id_fact]="data.debit"></app-debit-note>
  </div>
}
@if (data.vercredit) {
  <div>
    <app-ver-credito
      [id_fact]="data.vercredit"
      [concepts]="data.concepts"
    ></app-ver-credito>
  </div>
}
@if (data.verdebit) {
  <div>
    <app-ver-debito
      [id_fact]="data.verdebit"
      [concepts]="data.concepts"
    ></app-ver-debito>
  </div>
}
@if (data.addCompanies) {
  <div>
    <app-add-company
      [id_user]="data.id_user"
      [valuesForm]="data.valuesForm"
    ></app-add-company>
  </div>
}
@if (data.validAdress) {
  <div>
    <app-get-adress></app-get-adress>
  </div>
}
@if (data.registerMails) {
  <div>
    <app-crud-mails
      [listMails]="data.listMails"
      [groupMails]="data.groupMails"
    ></app-crud-mails>
  </div>
}
@if (data.registerBanks) {
  <div>
    <app-crud-banks
      [listBanks]="data.listBanks"
      [groupPayment]="data.groupPayment"
    ></app-crud-banks>
  </div>
}
@if (data.registerCashiers) {
  <div>
    <app-crud-cashiers
      [listCashiers]="data.listCashiers"
      [groupCashier]="data.groupCashier"
    ></app-crud-cashiers>
  </div>
}
@if (data.paymentLists) {
  <div>
    <app-crud-payment-lists
      [listBanks]="data.listBanks"
      [listCashiers]="data.listCashiers"
      [listMails]="data.listMails"
      [group]="data.group"
      [initialTabId]="data.initialTabId"
    ></app-crud-payment-lists>
  </div>
}
@if (data.registerGroups) {
  <div>
    <app-crud-groups [listGroups]="data.listGroups"></app-crud-groups>
  </div>
}
@if (data.registerPresen) {
  <div>
    <app-crud-presentations
      [listPresentations]="data.listPresen"
    ></app-crud-presentations>
  </div>
}
@if (data.registerWare) {
  <div>
    <app-crud-warehouse [listWare]="data.listWare"></app-crud-warehouse>
  </div>
}
@if (data.configInvoicePurchase) {
  <div>
    <app-pay-purchase
      [id_invoice]="data.identify_invoice"
      [id_provider]="data.idProvider"
      [invoicePayments]="data.invoicePayments"
    ></app-pay-purchase>
  </div>
}
@if (data.quotationList) {
  <div>
    <app-export-excel [quotationList]="data.quotationList"></app-export-excel>
  </div>
}
@if (data.currency === true) {
  <div>
    <app-select-currency [currency]="data.currency"></app-select-currency>
  </div>
}
@if (data.detailsArticle) {
  <div>
    <app-details-article [article]="data.article"></app-details-article>
  </div>
}
@if (data.detailsPayment) {
  <div>
    <app-detail-payment [details]="data.detailsPayment"></app-detail-payment>
  </div>
}
@if (data.registerMailsHome) {
  <div>
    <app-crud-mails-home></app-crud-mails-home>
  </div>
}
@if (data.modifyProvider) {
  <div>
    <app-modify-provider [id_provider]="data.id_provider"></app-modify-provider>
  </div>
}
@if (data.registerProvider) {
  <div>
    <app-register-provider></app-register-provider>
  </div>
}
@if (data.registrationModePurchase) {
  <div>
    <app-registration-mode></app-registration-mode>
  </div>
}
@if (data.registerPurchase && !data.purchaseForm) {
  <div>
    <app-register-purchase [XMLFIle]="data.XMLfile"></app-register-purchase>
  </div>
}
@if (data.registerPurchase && data.purchaseForm) {
  <div>
    <app-register-purchase
      [XMLFIle]="data.XMLfile"
      [purchaseForm]="data.purchaseForm"
      [newProvider]="data.newProvider"
      [totalPurchase]="data.totalPurchase"
      [totalTax]="data.totalTax"
      [totalWithoutTax]="data.totalWithoutTax"
      [withholdingTax]="data.withholdingTax"
      [uvtValue]="data.uvtValue"
      [icaTax]="data.icaTax"
      [providerCity]="data.providerCity"
      [customerCity]="data.customerCity"
    ></app-register-purchase>
  </div>
}
@if (data.id_purchaseInvoice) {
  <div>
    <app-modify-purchase
      [id_invoice]="data.id_purchaseInvoice"
    ></app-modify-purchase>
  </div>
}
@if (data.registerActivity) {
  <div>
    <app-register-activities></app-register-activities>
  </div>
}
@if (data.modifyActivity) {
  <div>
    <app-modify-activities
      [id_activity]="data.id_activity"
    ></app-modify-activities>
  </div>
}
@if (data.registerIcaBase) {
  <div>
    <app-register-ica-bases></app-register-ica-bases>
  </div>
}
@if (data.modifyIcaBase) {
  <div>
    <app-modify-ica-bases [icaBase]="data.icaBase"></app-modify-ica-bases>
  </div>
}
@if (data.registerDeclarantRate) {
  <div>
    <app-register-declarant-rate></app-register-declarant-rate>
  </div>
}
@if (data.modifyDeclarantRate) {
  <div>
    <app-modify-declarant-rate [rate]="data.rate"></app-modify-declarant-rate>
  </div>
}
@if (data.customersList) {
  <div>
    <app-customers-by-seller
      [customersList]="data.customersList"
    ></app-customers-by-seller>
  </div>
}
@if (data.accountingAccounts) {
  <div>
    <app-crud-accounting-accounts></app-crud-accounting-accounts>
  </div>
}
@if (data.id_account) {
  <div>
    <app-modify-accounting-accounts
      [id_account]="data.id_account"
    ></app-modify-accounting-accounts>
  </div>
}
@if (data.registerSegments) {
  <div>
    <app-crud-customer-segment
      [listSegments]="data.listSegments"
    ></app-crud-customer-segment>
  </div>
}
@if (data.refunds) {
  <div>
    <app-refunds [id_invoice]="data.id_purchaseRefund"></app-refunds>
  </div>
}
@if (data.refundsToFind) {
  <div>
    <app-refunds-list [purchaseInvoice]="data.refundsToFind"></app-refunds-list>
  </div>
}
@if (data.registerAdvencePayments) {
  <div>
    <app-register-treasury></app-register-treasury>
  </div>
}
@if (data.registerTransfers) {
  <div>
    <app-transfers
      [payment]="data.payment"
      [disable]="data.disable"
    ></app-transfers>
  </div>
}
@if (data.registerWarehouseTransfer) {
  <div>
    <app-crud-warehouse-transfer></app-crud-warehouse-transfer>
  </div>
}
@if (data.registerWarehouseOutputOrEntry) {
  <div>
    <app-crud-warehouse-output-and-entry
      [types]="data.types"
    ></app-crud-warehouse-output-and-entry>
  </div>
}
@if (data.registerReclassification) {
  <div>
    <app-crud-inventory-reclassification></app-crud-inventory-reclassification>
  </div>
}
@if (data.warehouseOpenings) {
  <div>
    <app-warehouse-openings [article]="data.article"></app-warehouse-openings>
  </div>
}
@if (data.modifyWarehouseOpenings) {
  <div>
    <app-update-warehouse-openings
      [opening]="data.opening"
    ></app-update-warehouse-openings>
  </div>
}
@if (data.forgotPassword) {
  <div>
    <app-forgot-password
      [documentTypes]="data.documentTypeList"
    ></app-forgot-password>
  </div>
}
@if (data.currencySelection) {
  <div>
    <app-currency></app-currency>
  </div>
}

@if (data.produceCompoundArticle) {
  <div>
    <app-produce-compound-article
      [compoundArticleId]="data.compoundArticleId"
    />
  </div>
}
